import {useQuery} from '@tanstack/react-query';

import {GetListOutput, GetListParams, QueryOptionsForList} from '@shared/api';
import {getVoucherConfigs} from '../api';
import {QUERY__VOUCHER_CONFIGS} from '../queryKeys';
import {VoucherConfig} from '../types';

export const useGetVoucherConfigs = <
  SelectedData = GetListOutput<VoucherConfig>,
>(
  params: GetListParams,
  options?: QueryOptionsForList<VoucherConfig, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__VOUCHER_CONFIGS, params],
    queryFn: () => getVoucherConfigs(params),
    ...options,
  });
};
